"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cancel = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var nucalm_1 = require("../../model/nucalm");
var service_1 = require("../../../library/base/service");
var Cancel = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Cancel, _super);
    function Cancel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '取消预约';
        _this.code = '101202';
        _this.desc = '取消预约';
        _this.requestParams = new nucalm_1.NucalmRequest();
        _this.method = fetch_1.Methods.GET;
        return _this;
    }
    return Cancel;
}(service_1.BaseService));
exports.Cancel = Cancel;
//# sourceMappingURL=cancel.js.map